/**
 * Agenda uma tarefa para rodar quando o navegador estiver ocioso (via
 * requestIdleCallback) ou, quando a API não existe (ex: Safari), no próximo
 * tick. Usado para tirar operações síncronas e potencialmente custosas (ex:
 * localStorage.setItem de payloads grandes) do caminho crítico de
 * renderização/interação do usuário.
 */
// requestIdleCallback não está no lib.dom desta versão do TypeScript.
type IdleWindow = Window & {
  requestIdleCallback?: (
    callback: () => void,
    options?: { timeout?: number }
  ) => number;
};

const runWhenIdle = (callback: () => void) => {
  const idleWindow: IdleWindow = window;

  if (typeof idleWindow.requestIdleCallback === "function") {
    idleWindow.requestIdleCallback(callback, { timeout: 1000 });
  } else {
    setTimeout(callback, 0);
  }
};

export default runWhenIdle;
